export const linkedAccounts = {
    enabled: false,
    _description: 'Enables the linked accounts feature on bank card settings page.',
};
